import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { Column, Table } from "@tanstack/react-table";
import FliterContent from "./Content";
import { Settings2, X } from "lucide-react";
export default function Fliter<T>({
  table,
  column,
}: {
  table: Table<T>;
  column: Column<T, unknown>;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="cursor-pointer text-[#333333] transition-colors duration-300 hover:text-primary">
          <Settings2 size={20} />
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        alignOffset={-12}
        sideOffset={-30}
        className="rounded-sm border border-[#babfc7] bg-white p-0 shadow-[0_1px_4px_1px_rbga(186,191,199,0.4)]">
        <div className="h-12 w-full bg-[#e8e8e8]">
          <div className="flex justify-end border-b border-[#ccc] p-4 text-[#555555]">
            <PopoverClose className=" outline-none">
              <X className="h-[14px] w-[14px]" />
            </PopoverClose>
          </div>
        </div>
        <FliterContent column={column} table={table} />
      </PopoverContent>
    </Popover>
  );
}
